export enum MatchStatus {
  NEW,
  MATCH,
  HIGH_LIKE,
  LIKE,
  DISLIKE,
  APPLICATION,
  TRASH,
}
